// 首先引入Mock
const Mock = require('mockjs')

const messageList = []
const count = 30
// 生成30条模拟数据
for (let i = 0; i < count; i++) {
  // 使用 Mock.mock 函数拦截请求
  messageList.push(Mock.mock({
    id: '@increment', // 随机生成标识
    'type|1': ['JSON', 'XML', 'HTTP'],
    'name|1': ['ICMP', 'TCP', 'UDP'],
    serviceAddress: '@url',
    interactiveCompany: '吉联',
    interactiveMode: '@protocol', // 随机生成一个url协议'
    params: '@word(5)'
  }))
}
const locationArr = []
locationArr.push(Mock.mock({
  city: '@city'
}))
 
module.exports = [
  {
    url: '/vue-element-admin/message/list',
    type: 'get',
    response: config => {
      const { name, page = 1, limit = 20 } = config.query

      let mockList = messageList.filter(item => {
        if (name && item.name.indexOf(name) === -1) return false
        return true
      })

      const pageList = mockList.filter((item, index) => index < limit * page && index >= limit * (page - 1))

      return {
        code: 20000,
        data: {
          total: mockList.length,
          data: pageList
        }
      }
    }
  },
  {
    url: '/vue-element-admin/message/getLocation',
    type: 'get',
    response: config => {
      return {
        code: 20000,
        data: {
          data: locationArr
        }
      }
    }
  }
]
